import { useMemo, useState } from 'react';
import classNames from 'classnames';
import { IRouletteFilters } from '~/types/common';
import styles from './styles/RouletteFilters.module.css';

interface Props {
  publicRooms: any[];
  filters: IRouletteFilters;
  onApply: (filters: IRouletteFilters) => void;
  onClose: () => void;
}

function RouletteFilters({ publicRooms, filters, onApply, onClose }: Props) {
  const [room, setRoom] = useState<string>(filters.roomFilter);
  const [gender, setGender] = useState<IRouletteFilters['genderFilter']>(filters.genderFilter);
  const [query, setQuery] = useState('');

  const filteredRooms = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return publicRooms;
    return publicRooms.filter(r => (r.name || '').toLowerCase().includes(q));
  }, [publicRooms, query]);

  const apply = () => onApply({ roomFilter: room, genderFilter: gender });

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.panel} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <span>Filtry doboru rozmówcy</span>
          <button className={styles.closeBtn} onClick={onClose}>×</button>
        </div>

        <div className={styles.section}>
          <label className={styles.label}>Płeć rozmówcy</label>
          <div className={styles.genderGrid}>
            <button
              className={classNames(styles.genderBtn, { [styles.selected]: gender === 'any' })}
              onClick={() => setGender('any')}
            >Dowolna</button>
            <button
              className={classNames(styles.genderBtn, { [styles.selected]: gender === 'female' })}
              onClick={() => setGender('female')}
            >Kobieta</button>
            <button
              className={classNames(styles.genderBtn, { [styles.selected]: gender === 'male' })}
              onClick={() => setGender('male')}
            >Mężczyzna</button>
          </div>
        </div>

        <div className={styles.section}>
          <label className={styles.label}>Pokój (zainteresowanie)</label>
          <input
            type="text"
            className={styles.search}
            placeholder="Szukaj pokoju…"
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
          <div className={styles.roomList}>
            <button
              className={classNames(styles.roomItem, { [styles.selected]: room === 'any' })}
              onClick={() => setRoom('any')}
            >Dowolny</button>
            {filteredRooms.map(r => (
              <button
                key={r.id}
                className={classNames(styles.roomItem, { [styles.selected]: room === r.id })}
                onClick={() => setRoom(r.id)}
              >{r.name}</button>
            ))}
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.applyBtn} onClick={apply}>Zastosuj</button>
        </div>
      </div>
    </div>
  );
}

export default RouletteFilters;
